import { Component, type ErrorInfo, type ReactNode } from 'react';
import { i18n } from '@/i18n';
import { ROUTES } from '@/routes';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="flex min-h-screen flex-col items-center justify-center gap-6 p-8 text-center">
          <h1 className="text-3xl font-semibold">
            {i18n.t('errors:boundary.title')}
          </h1>
          <p className="max-w-sm text-muted-foreground">
            {i18n.t('errors:boundary.message')}
          </p>
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="text-brand underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand focus-visible:rounded-sm"
            >
              {i18n.t('errors:boundary.refresh')}
            </button>
            <a href={ROUTES.home} className="text-muted-foreground underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand focus-visible:rounded-sm">
              {i18n.t('common:actions.back_home')}
            </a>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
